import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';
import { useTenant } from '../../context/TenantContext';
import { useUserInfo } from '../../context/UserInfoContext';
import { isManager } from '../../utils/user';

const MAX_RETRIES = 2;

// A 4XX answer would fail the same way again; a 5XX or a network error may not.
const isTransientError = (error) => !error.response || error.response.status >= 500;

export const useGetGroupList = () => {
  const client = useApi();
  const { userInfo } = useUserInfo();
  const { env } = useTenant();

  return useQuery(
    'group-list',
    () => client.get(`${env.REACT_APP_BACKEND_PORTAL_URL}/users/multi-access/kamGroup/list`).then((res) => res.data),
    {
      enabled: isManager(userInfo.role),
      retryOnMount: false,
      // Without a group list the manager's monitoring block stays hidden until the page reloads.
      retry: (failureCount, error) => failureCount < MAX_RETRIES && isTransientError(error),
    },
  );
};
